import { safetyTips } from "@/mocks/homeData";

export default function Safety() {
  return (
    <section id="safety" className="w-full scroll-mt-20 bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-400">SAFETY / 安全提示</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            观看前的安全提示
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
            越是来源不明的渠道，越容易夹带弹窗、跳转与诱导下载。下面这几条，能帮你在不影响观看的前提下，
            把风险降到最低。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {safetyTips.map((tip) => (
            <article
              key={tip.title}
              className="rounded-xl border border-foreground-800 bg-foreground-900 p-6 transition-colors hover:border-accent-600"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-base font-bold text-background-50">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}